import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/filtering";
function InstructionModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.IsLoading = ko.observable(false);
    self.Initialized = ko.observable(false);
    self.OnlyShowUnread = ko.observable();
    self.OnlyShowUnread.subscribe(function () {
        if (self.CurrentInstructionsPageIndex() == 0) {
            if (self.Initialized()) {
                self.LoadInstructions();
            }
        }
        else {
            self.CurrentInstructionsPageIndex(0);
        }
    });
    self.CurrentInstructionsCollection = ko.observableArray([]);
    self.SelectedCurrentInstructionRow = ko.observable({});
    self.CurrentInstructionsSorting = ko.observableArray();
    self.CurrentInstructionsSorting.subscribe(function () {
        if (self.Initialized()) {
            self.LoadInstructions();
        }
    });
    self.CustomFilter = ko.observable({});
    self.CustomFilter.subscribe(function () {
        if (self.Initialized()) {
            self.LoadInstructions();
        }
    });
    self.CurrentInstructionsTotalRows = ko.observable(0);
    self.CurrentInstructionsPageSize = ko.observable(10);
    self.CurrentInstructionsPageSize.subscribe(function () {
        if (self.Initialized()) {
            self.CurrentInstructionsPageIndex(0);
            self.LoadInstructions();
        }
    });
    self.CurrentInstructionsPageIndex = ko.observable(0);
    self.CurrentInstructionsPageIndex.subscribe(function () {
        if (self.Initialized()) {
            self.LoadInstructions();
        }
    });
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
    self.linkInstruction = function (index, instructionModel) {
        var linkHash = "instruction/" + instructionModel.InstructionId;
        baoRouter.setHash(linkHash);
    };
    self.LoadInstructions = function () {
        self.IsLoading(true);
        var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
        return Bao.post("Start/GetCurrentInstructions", JSON.stringify({
            date: parent.ValidDateJs(),
            pageIndex: self.CurrentInstructionsPageIndex(),
            pageSize: self.CurrentInstructionsPageSize(),
            sorting: self.CurrentInstructionsSorting(),
            onlyShowUnread: self.OnlyShowUnread(),
            customfilter: customFilter
        }), function (searchResult) {
            self.SelectedCurrentInstructionRow(null);
            self.CurrentInstructionsTotalRows(0);
            self.CurrentInstructionsCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.CurrentInstructionsCollection(searchResult.Models);
                self.CurrentInstructionsTotalRows(searchResult.TotalRows);
            }
            self.IsLoading(false);
        });
    };
    self.LoadUserProfile = function () {
        return Bao.post("Start/LoadInstructionModuleUserProfile", JSON.stringify({}), function (result) {
            if (result != null && result.onlyUnread != null) {
                self.OnlyShowUnread(result.onlyUnread === "true" ? true : false);
            }
            self.IsLoading(false);
        });
    };
    self.parent.Refresh = function () {
        self.LoadInstructions();
    };
    self.init = function () { };
    self.loaded = function () {
        var def = $.Deferred();
        self.IsLoading(false);
        Bao.bindEvent("instructions:refresh", function (value) {
            self.LoadInstructions();
        });
        self.LoadUserProfile().then(function () {
            self.LoadInstructions();
        });
        $.when(self.LoadInstructions()).done(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def;
    };
}
export default InstructionModuleViewModel;